import { render, staticRenderFns } from "./AppAwPay.vue?vue&type=template&id=7fba451e&"
import script from "./AppAwPay.vue?vue&type=script&lang=js&"
export * from "./AppAwPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports